import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/pages/Main'
import Login from '@/pages/Login'
import Categories from '@/pages/Categories'
import Contractors from '@/pages/Contractors'
import Customers from '@/pages/Customers'
import Carriers from '@/pages/Carriers'
import Loaders from '@/pages/Loaders'
import Suppliers from '@/pages/Suppliers'
import Users from '@/pages/Users'
import Configuration from '@/pages/Configuration'
import Shipments from '@/pages/Shipments'
import Sales from '@/pages/Sales'
import Supplier from '@/pages/Supplier'
import Orders from '@/pages/Orders'
import LabelReport from '@/pages/LabelReport'
import Transports from '@/pages/Transports'
import Pallets from '@/pages/Pallets'
import Employees from '@/pages/Employees'
import Log from '@/pages/Log'
import Public from '@/pages/public/Public'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Main', component: Main },
    { path: '/login', name: 'Login', component: Login },
    { path: '/dashboard', name: 'Dashboard', component: Main },
    { path: '/sales', name: 'Sales', component: Sales },
    { path: '/supplier', name: 'Supplier', component: Supplier },
    { path: '/orders', name: 'Orders', component: Orders },
    { path: '/labelling', name: 'LabelReport', component: LabelReport },
    { path: '/shipments', name: 'Shipments', component: Shipments },
    { path: '/transports', name: 'Transports', component: Transports },
    { path: '/pallets', name: 'Pallets', component: Pallets },
    { path: '/users', name: 'Users', component: Users },
    { path: '/categories', name: 'Categories', component: Categories },
    { path: '/contractors', name: 'Contractors', component: Contractors },
    { path: '/customers', name: 'Customers', component: Customers },
    { path: '/suppliers', name: 'Suppliers', component: Suppliers },
    { path: '/carriers', name: 'Carriers', component: Carriers },
    { path: '/loaders', name: 'Loaders', component: Loaders },
    { path: '/employees', name: 'Employees', component: Employees },
    { path: '/log', name: 'Log', component: Log },
    { path: '/configuration', name: 'Configuration', component: Configuration },
    { path: '/public/p', name: 'Public', component: Public }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js